import React, { FC } from 'react';
import styled from '@emotion/styled';
import ExpandableSection from '@app/components/ExpandableSection';
import { SupplierValidationRecord, SupplierValidationRecordStatus } from '@mortee/domain/validationSystem';
import { compareReasonsWithOtherLast } from '@mortee/routes/validationSystem/statusEdit/StatusReasonSelector';

interface Props {
  record: SupplierValidationRecord;
  className?: string;
}

const SupplierValidationRecordClarificationReasons: FC<Props> = ({ record, className }) => {
  // Other statuses (e.g. Canceled) carry reasons too, but only these are requests to the client
  if (record.status.value !== SupplierValidationRecordStatus.clarificationExternal || !record.status.reasons?.length) {
    return null;
  }

  const sortedReasons = [...record.status.reasons].sort(compareReasonsWithOtherLast);

  return (
    <ExpandableSection
      className={className}
      id='btn-supplier-validation-record-clarification-reasons'
      dataTestId='supplier-validation-record-clarification-reasons-header'
      header={`External Clarification reasons (${sortedReasons.length})`}
    >
      <ReasonList data-testid='supplier-validation-record-clarification-reasons-list'>
        {sortedReasons.map((reason) => (
          <li key={reason.id}>{reason.reason}</li>
        ))}
      </ReasonList>
    </ExpandableSection>
  );
};

export default SupplierValidationRecordClarificationReasons;

// No flex: a flex container blockifies <li> and drops the number markers.
const ReasonList = styled.ol`
  margin: 0;
  padding: 12px 16px 12px 40px;
  list-style: decimal outside;

  li:not(:last-child) {
    margin-bottom: 6px;
  }
`;
